export enum Role {
  FacultyMember = 'FacultyMember',
  Administrator = 'Administrator',
}



// WEBPACK FOOTER //
// ./src/app/classes/enmus.ts